import React from "react";
import SagaScreen from "kit/SageScreen";
import JobsList from "ui/home/dashboard/JobsList";
import DashboardUserSubtitle from "./dashboard/DashboardUserSubtitle";
import DashboardBalanceButton from "./dashboard/DashboardBalanceButton";

const Dashboard: React.FC = () => {
    return (
        <SagaScreen>
            <div className="row align-items-center">
                <div className="col">
                    <h1>Dashboard</h1>
                </div>
                <DashboardBalanceButton />
            </div>
            <DashboardUserSubtitle />
            <div className="row align-items-center">
                <div className="col">
                    <h2>Jobs</h2>
                    <p>
                        These are the jobs that you have created. You can create
                        new apps using the Rend A Hand on your computer.
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <JobsList />
                </div>
            </div>
        </SagaScreen>
    );
};

export default Dashboard;
